import router from '@/router'
import flightService from '@/services/flightService'
import passengersInformation from './passengersInformation/passengersInformation'
import searchParameters from './searchParameters/searchParameters'
import searchResults from './searchResults/searchResults'
import searchFilters from './searchFilters/searchFilters'
import booking from './booking/booking'
import moment from 'moment'
import _ from 'lodash'

const state = {
  step: '1',
  step2Loading: false,
  step3Loading: false,
  step4Loading: false
}

const mutations = {
  changeStep (state, n) {
    state.step = String(n)
  },
  changeStep2Loading (state, val) {
    state.step2Loading = val
  },
  changeStep3Loading (state, val) {
    state.step3Loading = val
  },
  changeStep4Loading (state, val) {
    state.step4Loading = val
  }
}

const getters = {
  getStep (state) {
    return state.step
  }
}

const actions = {
  resetStates ({ dispatch, commit }) {
    dispatch('fb/passengersInformation/resetStates', null, { root: true })
    dispatch('fb/searchFilters/resetStates', null, { root: true })
    dispatch('fb/searchResults/resetStates', null, { root: true })
    dispatch('fb/booking/resetStates', null, { root: true })
    commit('changeStep', '1')
  },
  async flightSearchAction ({ rootState, commit, dispatch }) {
    commit('changeStep2Loading', true)
    commit('fb/searchResults/changeItinerariesLoading', true, { root: true })
    dispatch('fb/searchParameters/changeSearchResultsStates', null, { root: true })
    commit('fb/passengersInformation/changeCommonSelectedLuggageOption', undefined, { root: true })
    commit('fb/changeStep', '2', { root: true })

    // Payload construction
    await dispatch('fb/searchParameters/constructSearchPayload', null, { root: true })

    // Actual request
    let response
    try {
      response = await flightService.search(rootState.fb.searchParameters.itineraryPayload)
    } catch (error) {
      commit('general/changeError', error, { root: true })
      commit('changeStep2Loading', false)
      return undefined
    }

    // console.log('RESPONSE SEARCH : ', _.cloneDeep(response))
    const responseDataPriceGroups = response.data.price_groups
    const responseDataOutwardFlights = response.data.outward_flights
    const responseDataReturnFlights = response.data.return_flights
    const responseDataItineraries = response.data.itineraries

    const itineraries = []
    let index = 0
    for (const group in responseDataPriceGroups) {
      const groupItineraries = []
      _.forEach(responseDataPriceGroups[group].outward_flights, function (outwardFlight) {
        let identifier = null
        const insurances = null
        let lastTicketDate = null
        let price = null
        let requestDatetime = null
        let ticketType = null
        let flightOutward = null
        let flightReturn = null
        let pcc = null

        flightOutward = _.cloneDeep(_.find(responseDataOutwardFlights, { unique_flight_id: outwardFlight.unique_flight_id }))
        flightOutward.identifier = flightOutward.unique_flight_id

        let oneWay = true
        _.forEach(outwardFlight.pairs, function (returnFlight) {
          oneWay = false
          // clone outward for have multi outward with different identifier
          flightOutward = _.cloneDeep(flightOutward)
          flightReturn = _.cloneDeep(_.find(responseDataReturnFlights, { unique_flight_id: returnFlight.unique_flight_id }))
          flightReturn.identifier = flightReturn.unique_flight_id

          const itR = _.cloneDeep(responseDataItineraries[returnFlight.options_fares[0].itinerary_id])
          price = itR.options_fares[0]

          // filtre des options non identique aller/retour (exemple Standard-Flex). On ne garde que les identiques aller/retour
          const opfs = itR.options_fares
          const opfsRes = []
          for (const i in opfs) {
            // plus necessaire pour le revalidate
            if (_.every(opfs[i].sbt_types_segments[0].segments, { brand_name: opfs[i].sbt_types_segments[0].segments[0].brand_name })) {
              opfsRes.push(opfs[i])
            }
          }
          var noPrice = false
          if (opfsRes.length === 0) {
            noPrice = true
            // console.log('NON PRICE FOR flightOutward', _.cloneDeep(flightOutward))
            // console.log('NON PRICE FOR flightReturn', _.cloneDeep(flightReturn))
            // console.log('NON PRICE FOR price', _.cloneDeep(price))
            // console.log('NON PRICE FOR itR', _.cloneDeep(itR))
            // console.log('NON PRICE FOR opfs', _.cloneDeep(opfs))
            // console.log('NON PRICE FOR itR.options_fares[0]', _.cloneDeep(itR.options_fares[0]))

            // ici on affiche finalement la combinaison la moins chere meme si pas de brand_name
            opfsRes.push(opfs[0])
            noPrice = false
          }

          price.options_fares = _.map(opfsRes, function (entry) {
            return _.omit(entry, 'options_fares')
          })

          identifier = itR.options_fares[0].identifier
          lastTicketDate = itR.last_ticket_date
          ticketType = itR.ticket_type
          requestDatetime = itR.request_datetime
          pcc = itR.pcc

          // set correct identifier with flight_id
          flightReturn.identifier = itR.options_fares[0].return_flight_id
          flightOutward.identifier = itR.options_fares[0].outward_flight_id
          // console.log(returnFlight.options_fares[0].itinerary_id + ' outward_flight_id : ' + itR.options_fares[0].outward_flight_id + ' return_flight_id : ' + itR.options_fares[0].return_flight_id)

          // update luggage information with real return flight
          const realReturn = _.find(responseDataPriceGroups[group].return_flights, { unique_flight_id: flightReturn.unique_flight_id })
          // console.log('realReturn : ', realReturn)
          const realOutward = _.find(realReturn.pairs, { unique_flight_id: flightOutward.unique_flight_id })
          // console.log('realOutward : ', realOutward)

          // console.log(Number(responseDataPriceGroups[group].from_price.value) + ' -> ' + outwardFlight.begin + ' ' + outwardFlight.unique_flight_id + ' -> ' + flightReturn.begin + ' ' + flightReturn.unique_flight_id, outwardFlight, realReturn)

          // compute supplier_class_description
          const detailOpOutward = itR.options_fares[0]

          flightOutward.details = _.cloneDeep(detailOpOutward.option_details[0].details)
          flightOutward.details.luggage_option = _.cloneDeep(detailOpOutward.option_details[0].luggage_option)

          // flightOutward.included_luggage = _.cloneDeep(realOutward.options_fares[0].included_luggage)
          flightOutward.included_luggage = outwardFlight.included_luggage
          flightOutward.quantity_included_luggage = _.cloneDeep(detailOpOutward.option_details[0].details[0].included_luggage)
          flightOutward.price_included_luggage = _.cloneDeep(realOutward.options_fares[0].included_luggage)
          price.price_included_luggage = _.cloneDeep(realOutward.options_fares[0].included_luggage)

          let cptSeg = 0
          _.forEach(detailOpOutward.option_details[0].segments[0].segment_ids, function (idseg) {
            flightOutward.segments[idseg].supplier_class_description = detailOpOutward.sbt_types_segments[0].segments[idseg].supplier_class_description
            flightOutward.segments[idseg].supplier_seat_cabin = detailOpOutward.sbt_types_segments[0].segments[idseg].brand_name
            cptSeg += 1
          })

          const detailOpReturn = itR.options_fares[0]

          flightReturn.details = _.cloneDeep(detailOpReturn.option_details[1].details)
          flightReturn.details.luggage_option = _.cloneDeep(detailOpReturn.option_details[1].luggage_option)

          // flightReturn.included_luggage = _.cloneDeep(returnFlight.options_fares[0].included_luggage)
          flightReturn.included_luggage = returnFlight.included_luggage
          flightReturn.quantity_included_luggage = _.cloneDeep(detailOpReturn.option_details[0].details[0].included_luggage)
          flightReturn.price_included_luggage = _.cloneDeep(returnFlight.options_fares[0].included_luggage)

          // console.log('SJISJI detailOpReturn : ', detailOpReturn)
          // console.log('SJISJI cptSeg flightReturn : ', cptSeg, flightReturn)

          if (detailOpReturn.provider_code === 'ND') {
            cptSeg = 0
          }
          _.forEach(detailOpReturn.option_details[1].segments[0].segment_ids, function (idseg) {
            // console.log('SJISJI idseg : ', idseg)
            let number = idseg - cptSeg
            // console.log('SJISJI number init : ', number)
            if (number < 0) {
              number = 0
            }
            // console.log('SJISJI number revu : ', number)
            flightReturn.segments[number].supplier_class_description = detailOpReturn.sbt_types_segments[0].segments[idseg].supplier_class_description ? detailOpReturn.sbt_types_segments[0].segments[idseg].supplier_class_description : ''
            flightReturn.segments[number].supplier_seat_cabin = detailOpReturn.sbt_types_segments[0].segments[idseg].brand_name ? detailOpReturn.sbt_types_segments[0].segments[idseg].brand_name : ''
          })

          if (!noPrice) {
            const itinerary = {}
            itinerary.identifier = identifier
            itinerary.flight_outward = flightOutward
            itinerary.flight_return = flightReturn
            itinerary.insurances = insurances
            itinerary.last_ticket_date = lastTicketDate
            itinerary.price = price
            itinerary.request_datetime = requestDatetime
            itinerary.ticket_type = ticketType
            itinerary.pnr_traveller_ind = false
            itinerary.pcc = pcc
            groupItineraries.push(itinerary)
          }
          // console.log(Number(responseDataPriceGroups[group].from_price.value) + ' -> ' + outwardFlight.begin + ' ' + outwardFlight.unique_flight_id + ' -> ' + flightReturn.begin + ' ' + flightReturn.unique_flight_id, outwardFlight, realReturn, itinerary)
        })

        if (oneWay) {
          const itR = responseDataItineraries[outwardFlight.options_fares[0].itinerary_id]
          price = itR.options_fares[0]

          const opfs = itR.options_fares

          price.options_fares = _.map(opfs, function (entry) {
            return _.omit(entry, 'options_fares')
          })

          price.price_included_luggage = outwardFlight.included_luggage
          identifier = itR.options_fares[0].identifier
          lastTicketDate = itR.last_ticket_date
          ticketType = itR.ticket_type
          requestDatetime = itR.request_datetime
          pcc = itR.pcc

          flightOutward.identifier = itR.options_fares[0].outward_flight_id
          flightOutward.included_luggage = outwardFlight.included_luggage
          flightOutward.price_included_luggage = _.cloneDeep(outwardFlight.options_fares[0].included_luggage)

          // compute supplier_class_description
          const detailOpOutward = itR.options_fares[0]

          _.forEach(detailOpOutward.option_details[0].segments[0].segment_ids, function (idseg) {
            flightOutward.segments[idseg].supplier_class_description = detailOpOutward.sbt_types_segments[0].segments[idseg].supplier_class_description
            flightOutward.segments[idseg].supplier_seat_cabin = detailOpOutward.sbt_types_segments[0].segments[idseg].brand_name
          })

          const itinerary = {}
          itinerary.identifier = identifier
          itinerary.flight_outward = flightOutward
          itinerary.insurances = insurances
          itinerary.last_ticket_date = lastTicketDate
          itinerary.price = price
          itinerary.request_datetime = requestDatetime
          itinerary.ticket_type = ticketType
          itinerary.pnr_traveller_ind = false
          itinerary.pcc = pcc
          groupItineraries.push(itinerary)
        }
      })

      itineraries.push({
        id: index,
        price: Number(responseDataPriceGroups[group].from_price.value),
        itinerary: groupItineraries
      })
      index += 1
    }

    // console.log('fin itineraries construct', itineraries)
    commit('fb/searchResults/changeItineraries', itineraries, { root: true })
    dispatch('fb/searchFilters/initSelectedAirlineCompanies', null, { root: true })
    commit('fb/passengersInformation/changeSelectedTravellers', rootState.fb.passengersInformation.searchParametersTravellers, { root: true })
    commit('changeStep2Loading', false)
    commit('fb/searchResults/changeItinerariesLoading', false, { root: true })
  },
  async flightFinalDetailsPutAction ({ commit }, payload) {
    commit('changeStep3Loading', true)
    commit('fb/changeStep', '3', { root: true })
    commit('fb/searchResults/changeSelectedItinerary', payload, { root: true })
    commit('fb/searchResults/resetItineraries', null, { root: true })
    let response
    try {
      response = await flightService.flightFinalDetails(payload)
      // console.log('flightFinalDetailsPutAction response : ', payload)
    } catch (error) {
      commit('changeStep3Loading', false)
      commit('general/changeError', 'error', { root: true })
      return undefined
    }

    // console.log('RESPONSE changeStep3Loading response', _.cloneDeep(response))
    const updatedItinerary = response.data.itinerary ? response.data.itinerary : response.data.itineraries[0]
    // console.log('RESPONSE changeStep3Loading updatedItinerary', _.cloneDeep(updatedItinerary))
    if (updatedItinerary) {
      if (!payload.insurances) {
        updatedItinerary.insurances = 'AISC insurance' // TODO, NO HARDCODED VALUE
      }
      if (!payload.last_ticket_date) {
        updatedItinerary.last_ticket_date = moment().format('YYYY-MM-DD') // TODO Find a better implementation ?
      }
      commit('fb/searchResults/changeUpdatedSelectedItinerary', updatedItinerary, { root: true })
      commit('changeStep3Loading', false)
    } else {
      commit('changeStep3Loading', false)
      commit('general/changeError', 'error', { root: true })
      return undefined
    }
  },
  async flightDetailsPostAction ({ commit, rootState }) {
    commit('changeStep4Loading', true)
    commit('changeStep', '4')

    // Have to do this because the backend is too dumb to process a non required field
    let phonePersonal = rootState.fb.passengersInformation.mobilePhoneNumber
    if (_.isEmpty(rootState.fb.passengersInformation.phoneNumber)) {
      phonePersonal = rootState.fb.passengersInformation.mobilePhoneNumber
    } else {
      phonePersonal = rootState.fb.passengersInformation.phoneNumber
    }

    const customer = _.cloneDeep(rootState.general.customer)

    customer.civility = rootState.general.customer.civility
    customer.first_name = rootState.general.customer.first_name
    customer.last_name = rootState.general.customer.last_name
    customer.birthday = rootState.general.customer.birthday
    customer.street_1 = rootState.fb.passengersInformation.contactAddress
    customer.city = rootState.fb.passengersInformation.contactCity
    customer.zip_code = rootState.fb.passengersInformation.contactZipCode
    customer.country_code = rootState.fb.passengersInformation.contactCountry.alpha_2_code
    customer.email = rootState.fb.passengersInformation.contactEmail
    customer.phone_mobile = rootState.fb.passengersInformation.mobilePhoneNumber
    customer.registration_number = rootState.general.customer.registration_number
    customer.phone_personnal = phonePersonal
    /*
    const customer = {
      civility: rootState.general.customer.civility,
      first_name: rootState.general.customer.first_name,
      last_name: rootState.general.customer.last_name,
      birthday: rootState.general.customer.birthday,
      street_1: rootState.fb.passengersInformation.contactAddress,
      city: rootState.fb.passengersInformation.contactCity,
      zip_code: rootState.fb.passengersInformation.contactZipCode,
      country_code: rootState.fb.passengersInformation.contactCountry.alpha_2_code,
      email: rootState.fb.passengersInformation.contactEmail,
      phone_mobile: rootState.fb.passengersInformation.mobilePhoneNumber,
      registration_number: rootState.general.customer.registration_number,

      connexion_token
      "country_name": "France",
      "phone_business": "",
      "street_2": "",
      "usage_first_name": "",
      "usage_last_name": "",

      phone_personnal: phonePersonal // Backend misspelled personal

      "family": [
        {
          "birthday": "1992-10-13",
          "civility": "mr",
          "first_name": "Clement",
          "last_name": "Buffle",
          "registration_number": "458407",
          "usage_first_name": "",
          "usage_last_name": ""
        }
      ],

    }
    */

    const travellers = _.cloneDeep(rootState.fb.passengersInformation.selectedTravellersDetails)
    const travellersPassport = _.cloneDeep(rootState.fb.passengersInformation.selectedTravellersPassportDetails)
    let resTravellers = []

    for (const traveller in travellers) {
      const index = _.findIndex(travellersPassport, ['registration_number', travellers[traveller].registration_number])
      if (index >= 0) {
        travellers[traveller].passport_country_code = travellersPassport[index].emissionCountry
        travellers[traveller].passport_expiry = travellersPassport[index].expirationDate
        travellers[traveller].passport_number = travellersPassport[index].number
      }
      const removeAccents = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      travellers[traveller].first_name = removeAccents(travellers[traveller].first_name.replace(/-/g, ' '))
      travellers[traveller].last_name = removeAccents(travellers[traveller].last_name.replace(/-/g, ' '))
      travellers[traveller].email = rootState.fb.passengersInformation.contactEmail
      travellers[traveller].phone_mobile = rootState.fb.passengersInformation.mobilePhoneNumber
      travellers[traveller].phone_personnal = phonePersonal
      resTravellers.push(travellers[traveller])
    }

    // map on travellers : delete selected_luggage_option property if selected_value undefined
    resTravellers = _.orderBy(resTravellers, ['birthday'], ['asc']).map(({
      selected_luggage_option,
      ...traveller
    }) => {
      const formatedLuggageOptions = _.cloneDeep(selected_luggage_option || {})
      if (!formatedLuggageOptions?.LuggageOptions?.selected_value) delete formatedLuggageOptions.LuggageOptions
      if (!formatedLuggageOptions?.OutwardLuggageOptions?.selected_value) delete formatedLuggageOptions.OutwardLuggageOptions
      if (!formatedLuggageOptions?.ReturnLuggageOptions?.selected_value) delete formatedLuggageOptions.ReturnLuggageOptions
      return { selected_luggage_option: formatedLuggageOptions, ...traveller }
    })

    // delete perBooking selected_luggage_option property if selected_value undefined
    const formatedPerBookingLuggageOptions = _.cloneDeep(rootState.fb.passengersInformation.selected_luggage_option || {})
    if (!formatedPerBookingLuggageOptions?.LuggageOptions?.selected_value) delete formatedPerBookingLuggageOptions.LuggageOptions
    if (!formatedPerBookingLuggageOptions?.OutwardLuggageOptions?.selected_value) delete formatedPerBookingLuggageOptions.OutwardLuggageOptions
    if (!formatedPerBookingLuggageOptions?.ReturnLuggageOptions?.selected_value) delete formatedPerBookingLuggageOptions.ReturnLuggageOptions

    const data = {
      itinerary: rootState.fb.searchResults.updatedSelectedItinerary,
      identifier: rootState.fb.searchResults.updatedSelectedItinerary.identifier,
      customer: customer,
      travellers: resTravellers,
      selected_luggage_option: formatedPerBookingLuggageOptions,
      payment_card_order: [
        {
          payment_card_id: 23,
          order: 1
        }
      ]
    }

    // console.log('REQUEST CREATE BOOKING', _.cloneDeep(data))

    // Service call , for SBT is create option here
    let response
    try {
      response = await flightService.bookingCreate(data)
    } catch (error) {
      commit('changeStep4Loading', false)
      commit('general/changeError', error, { root: true })
      return undefined
    }

    // console.log('RESPONSE CREATE BOOKING', _.cloneDeep(response))

    const updatedItinerary = await response.data.itinerary
    if (updatedItinerary.insurances === undefined) {
      updatedItinerary.insurances = rootState.fb.searchResults.updatedSelectedItinerary.insurances
    }

    if (updatedItinerary.last_ticket_date === undefined) {
      updatedItinerary.last_ticket_date = rootState.fb.searchResults.updatedSelectedItinerary.last_ticket_date
    }

    const bookingIdentifier = response.data.identifier

    commit('fb/passengersInformation/changeSelectedTravellersDetails', resTravellers, { root: true })
    commit('fb/searchResults/changeUpdatedSelectedItinerary', updatedItinerary, { root: true })
    commit('fb/booking/setBookingIdentifier', bookingIdentifier, { root: true })
    commit('fb/booking/setLuggageOptionsPerTrip', formatedPerBookingLuggageOptions, { root: true })
    commit('changeStep4Loading', false)
  },
  async bookingOption ({ commit, rootState }) {
    router.push({ name: 'RedirectionLoader' })

    // Have to do this because the backend is too dumb to process a non required field
    let phonePersonal = rootState.fb.passengersInformation.mobilePhoneNumber
    if (_.isEmpty(rootState.fb.passengersInformation.phoneNumber)) {
      phonePersonal = rootState.fb.passengersInformation.mobilePhoneNumber
    } else {
      phonePersonal = rootState.fb.passengersInformation.phoneNumber
    }

    const customer = _.cloneDeep(rootState.general.customer)

    customer.civility = rootState.general.customer.civility
    customer.first_name = rootState.general.customer.first_name
    customer.last_name = rootState.general.customer.last_name
    customer.birthday = rootState.general.customer.birthday
    customer.street_1 = rootState.fb.passengersInformation.contactAddress
    customer.city = rootState.fb.passengersInformation.contactCity
    customer.zip_code = rootState.fb.passengersInformation.contactZipCode
    customer.country_code = rootState.fb.passengersInformation.contactCountry.alpha_2_code
    customer.email = rootState.fb.passengersInformation.contactEmail
    customer.phone_mobile = rootState.fb.passengersInformation.mobilePhoneNumber
    customer.registration_number = rootState.general.customer.registration_number
    customer.phone_personnal = phonePersonal

    // Service call
    let response
    try {
      response = await flightService.bookingSendAISC({
        customer,
        travellers: rootState.fb.passengersInformation.selectedTravellersDetails,
        luggageOptionsPerTrip: rootState.fb.booking.luggageOptionsPerTrip,
        accessToken: rootState.general.token,
        bookingIdentifier: rootState.fb.booking.bookingIdentifier,
        detailFareRules: rootState.fb.searchResults.selectedItinerary.detail_fare_rules
      })
    } catch (error) {
      commit('general/changeError', error, { root: true })
      return undefined
    }

    let hasError = false
    const regex = RegExp('error', 'i')
    Object.keys(response.data).forEach((key) => {
      if (regex.test(key)) {
        hasError = true
      }
    })

    if (hasError) {
      commit('general/changeError', response.data, { root: true })
    } else {
      // redirect the user to the AISC website to proceed checkout
      location.assign(response.data.redirect_uri)
    }
  }
}

const modules = {
  passengersInformation,
  searchParameters,
  searchResults,
  searchFilters,
  booking
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules
}
